import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import CreateUrl from '@/components/CreateUrl'
import ListUrls from '@/components/ListUrls'
import Authenticator from '@/components/Authenticator'

import { AmplifyPlugin } from 'aws-amplify-vue'
import * as AmplifyModules from 'aws-amplify'
import AmplifyStore from '../store/store'
import { EventBus } from '../event-bus/event-bus'

Vue.use(Router)
Vue.use(AmplifyPlugin, AmplifyModules)

let user

// Plug event bus to detect user logout and login
EventBus.$on('authState', async (state) => {
  if (state.value === 'signedOut') {
    user = null
    AmplifyStore.commit('setUser', null)
    router.push({ path: state.redirectPath || '/' })
  } else if (state.value === 'signedIn') {
    user = await getUser()
    router.push({ path: state.redirectPath || '/' })
  }
})

// Define getUser function used above
function getUser () {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data) {
      // When current authenticated user found, store it in local storage
      AmplifyStore.commit('setUser', data)
      return data
    }
  }).catch((e) => {
    // When current authenticated user not found, drop local storage
    AmplifyStore.commit('setUser', null)
    return null
  })
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/create',
      name: 'CreateUrl',
      component: CreateUrl,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/urls',
      name: 'ListUrls',
      component: ListUrls,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/auth',
      name: 'Authenticator',
      component: Authenticator
    }
  ]
})

// Firewall: if user is not authenticated when resolving routes, redirect him to /auth
router.beforeResolve(async (to, from, next) => {
  user = await getUser()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath
        }
      })
    }
    return next()
  }
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js